import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggedOutGuard } from './Logged-out.guard';
import { LoggedInGuard } from './logged-in.guard';
import { TestLabelsGuard } from './test-labels.guard';
import { APP_ENVIRONMENT } from '../../utilities/services/environment.injection-token';
import { environment } from '../../environments/environment';
import { L10nTranslationModule } from 'angular-l10n';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {RouterModule} from '@angular/router';
import { UtilsService } from './utils.service';
import { MenuComponent } from './menu/menu.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DialogMessageComponent } from './dialog/dialog-message/dialog-message.component';
import { DialogService } from './dialog/dialog.service';
import {MatDialogModule} from '@angular/material/dialog';
import { DialogYesNoComponent } from './dialog/dialog-yes-no/dialog-yes-no.component';
import { UppercaseDirective } from 'src/utilities/directives/uppercase.directive';
import { NoAutocompleteDirective } from 'src/utilities/directives/autocomplete.directive';
import { NotSameEmailComponent } from '../notSameEmail/notSameEmail.component';
import { StatusHistoryComponent } from './components/status-history/status-history.component';
import { GenericListComponent } from './components/generic-list/generic-list.component';
import { MatPaginatorModule } from "@angular/material/paginator";
import { SearchComponentComponent } from './search-component/search-component.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { StatusCardComponent } from './components/status-card/status-card.component';
import { GenericFilterComponent } from './components/generic-filter/generic-filter.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    MainLayoutComponent,
    SpinnerComponent,
    DialogMessageComponent,
    DialogYesNoComponent,
    UppercaseDirective,
    NoAutocompleteDirective,
    StatusHistoryComponent,
    GenericListComponent,
    SearchComponentComponent,
    StatusCardComponent,
    GenericFilterComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    SpinnerComponent,
    UppercaseDirective,
    NoAutocompleteDirective,
    StatusHistoryComponent,
    GenericListComponent,
    SearchComponentComponent,
    StatusCardComponent,
    GenericFilterComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    L10nTranslationModule,
    MatDialogModule,
    ReactiveFormsModule,
    NgSelectModule,
    BsDatepickerModule,
    MatPaginatorModule
]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LoggedInGuard,
        LoggedOutGuard,
        TestLabelsGuard,
        [{ provide: APP_ENVIRONMENT, useValue: environment }],
        UtilsService,
        DialogService
      ]
    };
  }
 }
